var map = {
	"./001-mauritius.svg": 76517,
	"./003-austria.svg": 37591,
	"./004-oman.svg": 57262,
	"./005-ethiopia.svg": 6377,
	"./006-tanzania.svg": 87647,
	"./007-nicaragua.svg": 96315,
	"./008-estonia.svg": 91652,
	"./009-uganda.svg": 84380,
	"./010-slovenia.svg": 94315,
	"./011-zimbabwe.svg": 93822,
	"./012-sao-tome-and-prince.svg": 27421,
	"./013-italy.svg": 86380,
	"./014-wales.svg": 33022,
	"./015-el-salvador.svg": 47773,
	"./016-nepal.svg": 97418,
	"./017-christmas-island.svg": 90825,
	"./018-lebanon.svg": 10745,
	"./019-ceuta.svg": 91287,
	"./020-iraq.svg": 4710,
	"./021-cook-islands.svg": 14255,
	"./022-syria.svg": 54233,
	"./023-cocos-island.svg": 85303,
	"./024-honduras.svg": 1245,
	"./025-anguilla.svg": 63377,
	"./026-qatar.svg": 37126,
	"./027-american-samoa.svg": 30240,
	"./028-puerto-rico.svg": 23262,
	"./029-comoros.svg": 89176,
	"./030-north-korea.svg": 73380,
	"./031-corsica.svg": 42173,
	"./032-zambia.svg": 93190,
	"./033-saint-kitts-and-nevis.svg": 72364,
	"./034-china.svg": 41389,
	"./035-luxembourg.svg": 52791,
	"./036-central-african-republic.svg": 64799,
	"./037-jamaica.svg": 44149,
	"./038-cape-verde.svg": 4156,
	"./039-monaco.svg": 74718,
	"./040-bhutan.svg": 8539,
	"./041-paraguay.svg": 58240,
	"./042-aruba.svg": 7762,
	"./043-montserrat.svg": 73535,
	"./044-latvia.svg": 21070,
	"./045-andorra.svg": 11011,
	"./046-micronesia.svg": 21893,
	"./047-dominican-republic.svg": 2123,
	"./048-abkhazia.svg": 59348,
	"./049-tunisia.svg": 69535,
	"./050-mauritania.svg": 58153,
	"./051-cayman-islands.svg": 19507,
	"./052-kosovo.svg": 2605,
	"./053-ghana.svg": 6024,
	"./054-canary-islands.svg": 70831,
	"./055-scotland.svg": 90921,
	"./056-guinea-bissau.svg": 995,
	"./057-burundi.svg": 28290,
	"./058-myanmar.svg": 39419,
	"./059-gabon.svg": 41682,
	"./060-benin.svg": 96437,
	"./061-saba-island.svg": 78425,
	"./062-namibia.svg": 49438,
	"./063-japan.svg": 98680,
	"./064-lithuania.svg": 92654,
	"./065-eritrea.svg": 31748,
	"./066-chad.svg": 17209,
	"./067-kenya.svg": 70436,
	"./068-djibouti.svg": 90915,
	"./070-tuvalu-1.svg": 82885,
	"./071-serbia.svg": 88521,
	"./072-bonaire.svg": 49582,
	"./073-togo.svg": 72344,
	"./074-kazakhstan.svg": 10206,
	"./075-antigua-and-barbuda.svg": 94886,
	"./076-suriname.svg": 90348,
	"./077-jordan.svg": 41599,
	"./078-belize.svg": 5545,
	"./079-st-barts.svg": 40229,
	"./080-iceland.svg": 36547,
	"./081-bermuda.svg": 5136,
	"./082-united-nations.svg": 30871,
	"./083-somalia.svg": 33676,
	"./084-barbados.svg": 94597,
	"./085-solomon-islands.svg": 17624,
	"./086-nigeria.svg": 34678,
	"./087-aland-islands.svg": 50857,
	"./088-uruguay.svg": 34513,
	"./089-sint-maarten.svg": 8237,
	"./090-burkina-faso.svg": 39862,
	"./091-slovakia.svg": 2205,
	"./092-sierra-leone.svg": 13942,
	"./093-basque-country.svg": 41627,
	"./094-south-korea.svg": 41760,
	"./095-pitcairn-islands.svg": 59608,
	"./096-mozambique.svg": 90650,
	"./097-san-marino.svg": 68092,
	"./098-guatemala.svg": 29957,
	"./099-albania.svg": 17263,
	"./100-pakistan.svg": 94229,
	"./101-northern-cyprus.svg": 54156,
	"./102-balearic-islands.svg": 98216,
	"./103-marshall-island.svg": 70575,
	"./104-ecuador.svg": 41953,
	"./105-cameroon.svg": 30823,
	"./106-panama.svg": 71186,
	"./107-kwait.svg": 16595,
	"./108-armenia.svg": 51157,
	"./109-romania.svg": 2836,
	"./110-guinea.svg": 6498,
	"./111-afghanistan.svg": 68336,
	"./112-laos.svg": 92332,
	"./113-greenland.svg": 40582,
	"./114-british-virgin-islands.svg": 72329,
	"./115-hungary.svg": 57552,
	"./116-curacao.svg": 92899,
	"./117-angola.svg": 2682,
	"./118-malasya.svg": 51963,
	"./119-brunei.svg": 73689,
	"./120-bahamas.svg": 82129,
	"./121-new-zealand.svg": 73973,
	"./123-british-columbia.svg": 96749,
	"./124-vatican-city.svg": 92458,
	"./125-finland.svg": 98019,
	"./126-botswana.svg": 28925,
	"./127-sri-lanka.svg": 72259,
	"./128-spain.svg": 39725,
	"./129-ossetia.svg": 48971,
	"./130-sicily.svg": 82034,
	"./131-chile.svg": 16747,
	"./132-bosnia-and-herzegovina.svg": 40746,
	"./133-saudi-arabia.svg": 64461,
	"./134-liechtenstein.svg": 37754,
	"./135-belarus.svg": 79528,
	"./136-iran.svg": 56589,
	"./137-fiji.svg": 21510,
	"./138-bahrain.svg": 94030,
	"./139-venezuela.svg": 28653,
	"./140-east-timor.svg": 50601,
	"./141-azerbaijan.svg": 58748,
	"./142-tibet.svg": 99068,
	"./143-norway.svg": 89991,
	"./144-algeria.svg": 70789,
	"./145-ukraine.svg": 2070,
	"./146-gambia.svg": 87949,
	"./147-bangladesh.svg": 7778,
	"./148-madeira.svg": 11403,
	"./149-czech-republic.svg": 13009,
	"./150-bolivia.svg": 60507,
	"./152-kyrgyzstan.svg": 22155,
	"./153-cuba.svg": 95203,
	"./154-swaziland.svg": 25300,
	"./155-israel.svg": 78330,
	"./156-costa-rica.svg": 83253,
	"./157-republic-of-the-congo.svg": 93357,
	"./159-cambodia.svg": 13116,
	"./160-northern-marianas-islands.svg": 76468,
	"./161-ivory-coast.svg": 8921,
	"./162-germany.svg": 18667,
	"./163-papua-new-guinea.svg": 54969,
	"./164-croatia.svg": 49521,
	"./165-belgium.svg": 86020,
	"./166-morocco.svg": 40754,
	"./167-macao.svg": 80160,
	"./168-bulgaria.svg": 50565,
	"./169-liberia.svg": 82397,
	"./170-greece.svg": 31330,
	"./171-galapagos-islands.svg": 38228,
	"./172-st-lucia.svg": 51581,
	"./173-mali.svg": 77881,
	"./174-denmark.svg": 46399,
	"./175-rapa-nui.svg": 55141,
	"./176-lesotho.svg": 89705,
	"./177-colombia.svg": 14256,
	"./178-palau.svg": 52208,
	"./179-ireland.svg": 30381,
	"./180-french-polynesia.svg": 99785,
	"./181-trinidad-and-tobago.svg": 42735,
	"./182-niue.svg": 78931,
	"./183-hong-kong.svg": 86435,
	"./185-haiti.svg": 38062,
	"./186-dominica.svg": 76524,
	"./187-vanuatu.svg": 49459,
	"./188-peru.svg": 26110,
	"./189-equatorial-guinea.svg": 38502,
	"./190-uzbekistn.svg": 65208,
	"./191-tonga.svg": 36685,
	"./192-philippines.svg": 20752,
	"./193-norfolk-island.svg": 37431,
	"./194-malta.svg": 28720,
	"./195-france.svg": 37963,
	"./196-tajikistan.svg": 93469,
	"./197-melilla.svg": 29084,
	"./198-argentina.svg": 21756,
	"./199-sudan.svg": 89847,
	"./200-south-africa.svg": 93815,
	"./201-martinique.svg": 51043,
	"./202-taiwan.svg": 3855,
	"./203-sahrawi-arab-democratic-republic.svg": 71661,
	"./204-guernsey.svg": 67027,
	"./205-switzerland.svg": 62885,
	"./206-rwanda.svg": 75110,
	"./207-guam.svg": 75158,
	"./208-palestine.svg": 83162,
	"./209-indonesia.svg": 20308,
	"./210-grenada.svg": 5218,
	"./212-moldova.svg": 63270,
	"./213-gibraltar.svg": 73191,
	"./214-malawi.svg": 20347,
	"./215-falkland-islands.svg": 18633,
	"./216-england.svg": 72669,
	"./217-virgin-islands.svg": 25123,
	"./219-isle-of-man.svg": 95247,
	"./220-vietnam.svg": 43497,
	"./221-tuvalu.svg": 59207,
	"./222-niger.svg": 25076,
	"./223-turks-and-caicos.svg": 27856,
	"./224-portugal.svg": 30721,
	"./225-maldives.svg": 96855,
	"./227-senegal.svg": 56331,
	"./228-nauru.svg": 72970,
	"./229-turkmenistan.svg": 53249,
	"./231-libya.svg": 99996,
	"./232-yemen.svg": 89546,
	"./233-transnistria.svg": 82011,
	"./234-australia.svg": 85728,
	"./235-tokelau.svg": 96832,
	"./236-republic-of-macedonia.svg": 89018,
	"./238-thailand.svg": 7331,
	"./239-montenegro.svg": 81791,
	"./240-azores-islands.svg": 39166,
	"./241-st-vincent-and-the-grenadines.svg": 40044,
	"./242-madagascar.svg": 49015,
	"./244-south-sudan.svg": 83570,
	"./245-jersey.svg": 94002,
	"./246-india.svg": 22208,
	"./247-somaliland.svg": 64918,
	"./248-russia.svg": 21458,
	"./249-democratic-republic-of-congo.svg": 97331,
	"./250-sint-eustatius.svg": 27224,
	"./251-samoa.svg": 60208,
	"./253-seychelles.svg": 20144,
	"./254-nato.svg": 18228,
	"./256-georgia.svg": 86318,
	"./257-sardinia.svg": 2128,
	"./258-mongolia.svg": 16718,
	"./259-european-union.svg": 80246,
	"./261-kiribati.svg": 86909,
	"./262-hawaii.svg": 5970,
	"./AE.svg": 47980,
	"./AMZ.svg": 26166,
	"./AU.svg": 55388,
	"./AZ.svg": 57627,
	"./BE.svg": 91941,
	"./BR.svg": 61962,
	"./CA.svg": 9546,
	"./DE.svg": 1447,
	"./EG.svg": 75098,
	"./EN.svg": 48307,
	"./ES.svg": 44758,
	"./FR.svg": 36654,
	"./IN.svg": 36031,
	"./IT.svg": 59221,
	"./JP.svg": 73920,
	"./MX.svg": 24485,
	"./NL.svg": 76112,
	"./NULL.svg": 16073,
	"./PL.svg": 31954,
	"./RU.svg": 16773,
	"./SA.svg": 82714,
	"./SE.svg": 21382,
	"./SG.svg": 92644,
	"./TR.svg": 43176,
	"./UK.svg": 86334,
	"./US.svg": 70886
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 84890;